/**
 * scrollToTop
 * @param scrollTrigger A boolean that triggers scrolling to top when true
 * @param behavior Optional scroll behavior ('auto' or 'smooth'), default is 'smooth'
 * @param topVal Optional top position to scroll to, default is 370
 */
export default function scrollToTop(
	scrollTrigger: boolean,
	behavior: ScrollBehavior = "smooth",
	topVal = 370,
): void {
	if (scrollTrigger) {
		window.scrollTo({ top: topVal, behavior });
	}
}
